import React, { Component } from 'react';

import { trans } from '../../../../../../localization';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../../../components/Table/PageTable';
import { formatCurrency } from '../../../../../../utils/utils';
import { getTotalPriceDishRejectOrder } from '../routines';

function ToppingDishItem({ options, listToppingOutOfStock }) {
  const listToppingIdOutOfStock = listToppingOutOfStock.map(
    toppingItem => toppingItem.toppingId,
  );
  const listTopping =
    options &&
    options.reduce((arrayTopping, topping) => [
      ...arrayTopping,
      ...topping.attributes.map((attribute) => {
        const isOutOfStock = listToppingIdOutOfStock.includes(attribute.id);
        return {
          id: attribute.id,
          icon: isOutOfStock ? 'fa-times text-danger' : 'fa-check text-green',
          groupToppingName: topping.name,
          toppingName: attribute.name,
        };
      }),
    ], []);
  return (
    <div className="dish-topping">
      {listTopping.map((topping) => {
        const {
         id, icon, groupToppingName, toppingName,
        } = topping;
        return (
          <p key={id}>
            <span className="color-black">
              <i className={`fa ${icon} mr-1`} />
              {groupToppingName}
            </span>
            : {toppingName}
          </p>
        );
      })}
    </div>
  );
}

class RejectOrderDishTable extends Component {
  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('mod_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'dish_name',
        label: trans('mod_detail_dish_name'),
        width: '40%',
        textAlign: 'left',
      },
      {
        id: 'quantity',
        label: trans('mod_detail_quantity'),
        width: '10%',
        textAlign: 'center',
      },
      {
        id: 'unit_price',
        label: trans('mod_detail_unit_price'),
        width: '15%',
        textAlign: 'center',
      },
      {
        id: 'total_price',
        label: trans('mod_detail_total_price'),
        width: '15%',
        textAlign: 'center',
      },
      {
        id: 'out_of_stock',
        label: trans('mod_detail_edit'),
        width: '15%',
        textAlign: 'center',
      },
    ];

    return <PageTableHeader columns={columns} />;
  }

  renderRow = (row, index) => {
    const {
      setEditDishOutOfStock,
      outOfStockOrder,
      priceUpdateOrder,
    } = this.props;
    const {
      toppings: listToppingOutOfStock = [],
      dishes: listDishOutOfStock = [],
    } = outOfStockOrder;
    const {
      id, note: dishNote, quantity: quantityDish, dish, options,
    } = row;

    const { id: dishId, name: dishName } = dish;

    const listTopping = options.reduce(
      (group, value) => [...group, ...value.attributes],
      [],
    );

    const totalPriceValue = getTotalPriceDishRejectOrder({
      priceUpdateOrder,
      outOfStockOrder,
      listTopping,
      itemDish: row,
    });

    // Check out of stock
    const dishOutOfStockCurrent = listDishOutOfStock.find(
      dishOutOfStock => dishOutOfStock.dishId === dishId,
    );

    const quantityDishAvailable = dishOutOfStockCurrent ? 0 : quantityDish;

    const totalPrice = quantityDishAvailable * totalPriceValue;

    return (
      <PageTableRow key={id}>
        <PageTableCell textAlign="center">{index}</PageTableCell>
        <PageTableCell textAlign="left">
          <strong
            className="color-black"
            style={{
              textDecoration: dishOutOfStockCurrent ? 'line-through' : 'none',
            }}
          >
            {dishName}
          </strong>
          <ToppingDishItem
            options={options}
            listToppingOutOfStock={listToppingOutOfStock}
          />
          <div className="font12">
            <i>{dishNote}</i>
          </div>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <span className="font12">{quantityDishAvailable}</span>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <span className="font12">{formatCurrency(totalPriceValue)}</span>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <span className="font12">{formatCurrency(totalPrice)}</span>
        </PageTableCell>
        <PageTableCell textAlign="center">
          <button
            type="button"
            className="btn btn-white button-control"
            onClick={() => setEditDishOutOfStock(row)}
          >
            <i className="fas fa-edit" />
          </button>
        </PageTableCell>
      </PageTableRow>
    );
  };

  render() {
    const { itemDetail } = this.props;
    const { group_items: groupItems } = itemDetail;
    const itemList = groupItems.reduce(
      (listItem, group) => [...listItem, ...group.items.order_dish],
      [],
    );
    const table = {
      itemList,
      totalSize: itemList.length,
    };

    return (
      <PageTable
        renderHeader={RejectOrderDishTable.renderHeader}
        renderRow={this.renderRow}
        table={table}
        isPagination={false}
        isShowFooter={false}
      />
    );
  }
}
export default RejectOrderDishTable;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/RejectOrder/components/RejectOrderDishTable.jsx